import Vue from 'vue';
import numeral from 'numeral';

numeral.register('locale', 'id', {
  delimiters: {
    thousands: '.',
    decimal: ',',
  },
  abbreviations: {
    thousand: 'ribu',
    million: 'juta',
    billion: 'mi',
    trillion: 'tr',
  },
  currency: {
    symbol: 'Rp. ',
  },
});

numeral.locale('id');

Object.defineProperties(Vue.prototype, {
  $numeral: {
    get() {
      return numeral;
    },
  },
});
